import React from 'react';
import { AuthenticationType } from '../../Types/AuthenticationType';

const initValue: AuthenticationType = {
    token: undefined,
    login: undefined
}

const MainContext = React.createContext(initValue);

export default MainContext;
